(function($) {

    // Extends jQuery to search while including seld
    $.fn.findClosest = function(selector) {
        return this.is(selector) ? this.filter(selector).first() : this.find(selector).first();
    };

    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    // Extend jQuery to allow serialization of a form to a JSON object
    // https://jsfiddle.net/gabrieleromanato/bynaK/
    $.fn.serializeFormJSON = function () {

        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name]) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    $(document).ready(function() {

        if (getParameterByName('login') == 'failed')
        {
            $('.login-main-ctn').addClass('open-login');
            $(this).parent().addClass('login-active');
            $('#user_login').addClass('error-field');
            $('#user_pass').addClass('error-field');
        }

        var videoPlayers = {};
        // ADD PLACEHOLDERS TO WP LOGIN
        if($('body').hasClass('en')){
            $('#user_login').attr('placeholder', 'Email');
            $('#user_pass').attr('placeholder', 'Password');
        }else {
            $('#user_login').attr('placeholder', 'Courriel');
            $('#user_pass').attr('placeholder', 'Mot de passe');
        }

        //OPEN LOGIN BOX
        $('#login-btn').on('click', function (e) {
            e.preventDefault();
            $('.login-main-ctn').toggleClass('open-login');
            $(this).parent().toggleClass('login-active');
        });

        //SHOW THE SLIDES (CONTACT, AGENDA, PROFIL?)
        $('.show-slide').on('click', function (e) {
            e.preventDefault();
            $('.close-slide').click();
            $('body').addClass('body-overflow-hidden');
            var slideID, $selector;

            if($(this).is('a')){
                $selector = $(this);
            } else{
                $selector = $(this).find('a').eq(0);
            }

            slideID = $selector.attr('href').substring(1);

            $('#slide-'+slideID).addClass('slideMe');
        });

        //SMOOTH-SCROLL
        $('.smooth-scroll').on('click', function (e) {
            e.preventDefault();
            var selector;
            if($(this).is('a')){
                selector = $(this).attr('href');
            } else{
                selector = $(this).find('a').eq(0).attr('href');
            }

            var homeUrl = ['/','/fr/accueil/','/veterinary/home/','/fr/veterinaire/accueil/'];
            if(homeUrl.indexOf(window.location.pathname) !== -1){
                selector = selector.substring(selector.indexOf('/#')+1);
                $('html, body').animate({ scrollTop: $(selector).offset().top }, 1000);
            }else{
                window.location.href = selector;
            }
        });

        //CLOSE SLIDE
        $('.close-slide').on('click', function (e) {
            e.preventDefault();
            $('body').removeClass('body-overflow-hidden');
            $(this).parent().parent().removeClass('slideMe');
        });

        $(".close-country-modal-btn").on('click', function(e) {
            $('.country-modal').css('display', 'none');
        });

        $(".close-country-modal-btn, #continue-country-modal-btn").on('click', function(e) {
            sessionStorage.setItem('blucare-country-modal-shown', true);
        });

        $(".country-selection-btn").on("change", function() {
            if($(this).val() !== "#")
                window.location.href = $(this).val();
        });

        if(sessionStorage.getItem('blucare-country-modal-shown') === null){
            $(".country-modal").css('display','block');
        }

        $('.close-modal').on('click', function(e) {
            e.preventDefault();

            var $modalMainCtn = $(this).parent().parent().parent(),
                $slideInnerCtn = $modalMainCtn.siblings('.slide-inner-ctn');
            $slideInnerCtn.find('form').trigger('reset');
            $modalMainCtn.fadeOut(250, function() {
                $slideInnerCtn.find('.close-slide').click();
            });
        });

        $('#slide-profil .cancel-btn').on('click', function(e) {
            e.preventDefault();
            $('.close-slide').click();
        });

       $('.slider-video-nav  .slick-dots button').on('click', function () {
            setTimeout(getSlideIndex, 300);
        });
        $('.slider-video-nav  .slick-arrow').on('click', function () {
            setTimeout(getSlideIndex, 300);
        });

        function getSlideIndex(){
            var slideIndex = $('.video-slider .slide-content-ctn.slick-active').attr('class').split(' ')[1];
            $('.videoIndex').html(parseInt(slideIndex.substring(1)) + 1);
        }

        //CONSUMER WEBSITE

        $('#menu-btn').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('.main-nav').toggleClass('open-menu');
        });

        var closeVideo = function($vid){
            $(window).unbind('scroll', scrollListener);
            $('.slider-video-nav').show();
            var index = $vid.parent('.slick-slide').data('slickIndex');
            $vid.fadeOut(500, function(e){
                $vid.siblings('.slide-inner').fadeIn(function(e){
                    var $videoContainerIndex = $(this).closest('section').attr('id');
                    $('#'+$videoContainerIndex).css('minHeight', 'max-content').css({ height: '100%' });
                    videoPlayers[$videoContainerIndex][index].pause();
                });
            });
        };

        // SLIDERS
        var scrollListener = function(event){
            var $vid = $('.slick-active').find('.video-player:visible');
            var $firstVid = $vid.closest('section');
            var sTop = $firstVid.position().top,
                sHeight = $firstVid.height(),
                windowScroll = $(window).scrollTop(),
                percent = 10,
                whereToStop = (sTop+sHeight)+((sTop+sHeight)/100*percent);
            if(whereToStop <= windowScroll){
                setTimeout(function(e){
                    closeVideo($vid);
                },500);
            }
        };

        // SLIDERS

        $('.consumer-testimonial-slider').slick({
            dots: true,
            //prevArrow: $('.arrow.left-arrow'),
            //nextArrow: $('.arrow.right-arrow'),
            appendArrows: '.slider-nav',
            appendDots: '.slider-nav',
            adaptativeHeight: true,
            autoplay:true,
            // autoplay:true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: false
                    }
                }
            ]
        });

        $('.testimonial-slider').slick({
            // fade: true,
            dots: true,
            // autoplay:true,
            autoplaySpeed:3000,
            draggable: false,
            appendArrows: '.slider-nav',
            appendDots: '.slider-nav',
            adaptiveHeight: true,
            // infinite:false,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: false,
                        arrows: false
                    }
                }
            ]
        });

        $('.video-slider').slick({
            // fade: true,
            dots: true,
            // autoplay:true,
            // autoplaySpeed:3000,
            draggable: false,
            appendArrows: '.slider-video-nav',
            appendDots: '.slider-video-nav',
            adaptiveHeight: true,
            infinite:false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: false,
                        arrows: false,
                        draggable: true
                    }
                }
            ]
        });


        $('.cta-video-ctn').click(function(e){
            var $slide = $(this).closest('.slide-inner');
            var $videoContainerIndex = $(this).closest('section').attr('id');
            var index = $slide.parent('.slick-slide').data('slickIndex');

            $('.slick-list').addClass('overflow-visible');

            $('html, body').animate({ scrollTop: $slide.siblings('.video-player').eq(0).offset().top -100 }, 250);
            $slide.fadeOut(500, function(e){
                $('.slider-video-nav').hide();
                $slide.siblings('.video-player').eq(0).fadeIn(function(e){
                    $('#'+$videoContainerIndex).css('minHeight', 0).animate({ height: $(this).find('iframe').eq(0).height() +150 }, 250);
                    $('html, body').animate({ scrollTop: $slide.siblings('.video-player').eq(0).offset().top - 100 }, 250, function() {
                        var video = videoPlayers[$videoContainerIndex][index];
                        var isPlaying = video.currentTime > 0 && !video.paused && !video.ended
                            && video.readyState > 2;
                        if (!isPlaying) {
                            video.play();
                        }
                        $(window).scroll($.throttle(250, scrollListener));
                    });

                });
            });
        });

        $('.close-video').click(function(e){
            e.preventDefault();
            var $vid = $(this).closest('.video-player');
            closeVideo($vid);
            $('.slick-list').removeClass('overflow-visible');
        });

        $('.video-player .video').each(function(j){
            var vkey = $(this).closest('section').attr('id');
            videoPlayers[vkey] = videoPlayers[vkey] || [];
            videoPlayers[vkey].push(new Vimeo.Player(this, {
                url: $(this).data('videoUrl'),
                autoplay:false,
                autopause:true,
                portrait:false,
                title:false
            }));
        });

        $('.partner-slider').slick({
            // fade: true,
            dots: true,
            autoplay:true,
            autoplaySpeed:3000,
            draggable: false,
            appendArrows: '.partner-slider-nav',
            appendDots: '.partner-slider-nav',
            adaptiveHeight: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        dots: true,
                        arrows: true,
                        draggable: true,
                        slidesToShow: 1
                    }
                }
            ]
        });

        $('.close-go-vet').on('click', function (e) {
            e.preventDefault();
            $(this).parent().addClass('hideMe');
        });

        //Make sure the form is there before doing anything (otherwise, JS error)
        var phoneField = $("input[type='telephone']");
        if(phoneField.length > 0 && typeof phoneField.intlTelInput !== "undefined"){
            phoneField.intlTelInput({
                // utilsScript: "/content/themes/blucare/dist/js/utils.js"
            });
        }

        //Force refresh woocommerce cart to avoid translation problems,
        // taken from  https://orbisius.com/blog/make-woocommerce-refresh-cart-contents-widget-p3200
        /** Set the cart hash in both session and local storage */
        function set_cart_hash( cart_hash ) {
            if ( $supports_html5_storage ) {
                localStorage.setItem( cart_hash_key, cart_hash );
                sessionStorage.setItem( cart_hash_key, cart_hash );
            }
        }

        /* Storage Handling */
        var $supports_html5_storage = true,
            cart_hash_key           = wc_cart_fragments_params.cart_hash_key;

        try {
            $supports_html5_storage = ( 'sessionStorage' in window && window.sessionStorage !== null );
            window.sessionStorage.setItem( 'wc', 'test' );
            window.sessionStorage.removeItem( 'wc' );
            window.localStorage.setItem( 'wc', 'test' );
            window.localStorage.removeItem( 'wc' );
        } catch( err ) {
            $supports_html5_storage = false;
        }

        /* Cart session creation time to base expiration on */
        function set_cart_creation_timestamp() {
            if ( $supports_html5_storage ) {
                sessionStorage.setItem( 'wc_cart_created', ( new Date() ).getTime() );
            }
        }

        var $fragment_refresh = {
            url: wc_cart_fragments_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'get_refreshed_fragments' ),
            type: 'POST',
            success: function( data ) {

                if ( data && data.fragments ) {

                    $.each( data.fragments, function( key, value ) {
                        $( key ).replaceWith( value );
                    });

                    if ( $supports_html5_storage ) {
                        sessionStorage.setItem( wc_cart_fragments_params.fragment_name, JSON.stringify( data.fragments ) );
                        set_cart_hash( data.cart_hash );

                        if ( data.cart_hash ) {
                            set_cart_creation_timestamp();
                        }
                    }

                    $( document.body ).trigger( 'wc_fragments_refreshed' );
                }
            }
        };
        $.ajax( $fragment_refresh );
    });
}(jQuery));


